import {
    BillingProvider,
    CurrentDossierProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DocumentSignModalProvider,
    DocumentSignModalWrapper,
    DossierDocumentSignProvider,
    DossierDocumentsProvider,
    DossierPrescriberProvider,
    DossierRoutingProvider,
    dossiersBasePath,
} from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ordersBasePath } from '../../../Orders';
import { DetailDossierHeader, DossierBody } from '../../components';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    if (!idDossier) {
        console.log(`Dossier non trouvé paramètres url:  ${idDossier}`);
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <DocumentPreviewProvider>
                <Container maxWidth="lg">
                    <CurrentDossierProvider
                        autoload
                        idDossier={idDossier}
                    >
                        <DocumentSignModalProvider>
                            <DossierDocumentSignProvider>
                                <DossierPrescriberProvider>
                                    <DossierDocumentsProvider
                                        autoload
                                        dossierIds={[idDossier as unknown as string]}
                                    >
                                        <BillingProvider>
                                            <DetailDossierHeader />
                                            <DossierBody />
                                        </BillingProvider>
                                        <DocumentSignModalWrapper />
                                    </DossierDocumentsProvider>
                                </DossierPrescriberProvider>
                            </DossierDocumentSignProvider>
                        </DocumentSignModalProvider>
                    </CurrentDossierProvider>
                </Container>
                <DocumentPreviewOverlay />
            </DocumentPreviewProvider>
        </DossierRoutingProvider>
    );
};

export default DetailDossier;
